import { useState } from "react";
import FormStep1 from "./FormStep1";
import "./create-jobs.scss";
import FormStep2 from "./FormStep2";
import FormStep3 from "./FormStep3";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import banner_bg from "assets/images/defaultBannerPage.png";
import logo from "assets/images/logo-nexogic.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";

const CreateJobs = () => {
  const [modal, setModal] = useState(false);

  const openModal = () => setModal(!modal);
  return (
    <div className="create-job-container">
      <FormStep1 />
      <br />
      <FormStep2 openModal={openModal} />
      <br />
      <FormStep3 openModal={openModal} />

      <Modal
        backdrop="static"
        centered
        scrollable
        isOpen={modal}
        openModal={openModal}
        className="preview-wrapper"
      >
        <ModalHeader toggle={openModal}>
          Job Preview
          <p className="preview-txt">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt orem ipsum dolor sit amet, consectetur
            adipisicing elit, sed do eiusmod tempor incididunt
          </p>
        </ModalHeader>

        <ModalBody className="p-0">
          <div className="prev-banner-main">
            <div className="preview-banner">
              <img src={banner_bg} alt="#" />
            </div>
            <div className="preview-job-provider">
              <img src={logo} className="job-provider-img" alt="#" />

              <div className="prev-content-part">
                <div className="txt-content">
                  <h3 className="sales-title">Lorem ipsum dolor</h3>
                  <p className="sales-desc">
                    Lorem ipsum &#9679; dolor sit amet, consectetur
                  </p>
                </div>
                <div className="apply-button-sec">
                  <Button color="info" outline>
                    Save
                  </Button>
                  <Button color="info">Apply</Button>
                </div>
              </div>
            </div>
          </div>
          <div className="preview-body-content">
            <Row>
              <Col md={8}>
                <div className="descrption-txt">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                  <h6 className="mt-2">
                    <strong>Responsibilities</strong>
                  </h6>
                  <ul>
                    <li> Lorem ipsum dolor sit amet</li>
                    <li>Lorem ipsum dolor sit amet consectetur adipisicing </li>
                    <li>
                      Lorem ipsum dolor sit amet reprehenderit in voluptate
                    </li>
                  </ul>
                  <h6 className="mt-2">
                    <strong>Qualification</strong>
                  </h6>
                  <ul>
                    <li> Lorem ipsum dolor sit amet</li>
                    <li>Lorem ipsum dolor sit amet consectetur adipisicing </li>
                    <li>
                      Lorem ipsum dolor sit amet reprehenderit in voluptate
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={4}>
                <div className="job-type-right">
                  <label>Job Type</label>
                  <p>Permanent</p>
                </div>
                <div className="job-type-right">
                  <label>Experience</label>
                  <p> 2 - 20 Years</p>
                </div>
                <div className="job-type-right">
                  <label>Work Shift</label>
                  <p> First Shift</p>
                </div>
                <div className="job-type-right">
                  <label>Salary</label>
                  <p>
                    <span>
                      <FontAwesomeIcon icon={faRupeeSign} /> 10000 -
                    </span>
                    <span className="ml-2">
                      <FontAwesomeIcon icon={faRupeeSign} /> 50000
                    </span>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
          <div className="footer-action">
            <Button color="primary" onClick={openModal}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreateJobs;
